var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarDeliverables(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 15.071,
    viewBox: "0 0 17.5 15.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9322",
    "data-name": "Group 9322",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13570",
    "data-name": "Path 13570",
    d: "M18.786,4H4.214A1.218,1.218,0,0,0,3,5.214V17.357a1.218,1.218,0,0,0,1.214,1.214H18.786A1.218,1.218,0,0,0,20,17.357V5.214A1.218,1.218,0,0,0,18.786,4Zm0,13.357H4.214V5.214H18.786Z",
    transform: "translate(-3 -4)",
    fill: "#8374ca",
    stroke: "#8374ca",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7179",
    "data-name": "Rectangle 7179",
    width: 5.457,
    height: 1,
    transform: "translate(2.095 3.701)",
    fill: "#8374ca",
    stroke: "#8374ca",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7180",
    "data-name": "Rectangle 7180",
    width: 5.457,
    height: 1,
    transform: "translate(2.095 6.786)",
    fill: "#8374ca",
    stroke: "#8374ca",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7181",
    "data-name": "Rectangle 7181",
    width: 5.457,
    height: 1,
    transform: "translate(2.095 9.87)",
    fill: "#8374ca",
    stroke: "#8374ca",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13571",
    "data-name": "Path 13571",
    d: "M12.294,12.584,15.775,9.1l-.861-.873-2.62,2.608-.861-.861-.873.861Z",
    transform: "translate(-1.652 -3.122)",
    fill: "#8374ca",
    stroke: "#8374ca",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDeliverables);
export default __webpack_public_path__ + "static/media/sidebar_deliverables.eb798931071dc2640c236e2659917204.svg";
export { ForwardRef as ReactComponent };